//Picture imports
import linkedinIcon from '../website-images/contact-page/linkedin-logo.jpg';
import githubIcon from '../website-images/contact-page/github-logo.jpg';
import phoneIcon from '../website-images/contact-page/phone-call.jpg';
import emailIcon from '../website-images/contact-page/email-icon.jpg';
import contactMe from '../website-images/contact-page/contact-me.jpg';

function Contact() {
    return (
        <section className="contact-page">
            <article className="intro-content">
                    <img src={contactMe} alt="person holding phone" />
                    <div className="text-content">
                        <h2>Contact Me</h2>
                        <p>Here are the various methods that can be used to contact me. I will answer you as soon as I can.</p>
                    </div>
            </article>
            <section className="contact-methods-section">
                <article className="single-contact-method">
                        <img className="contact-icon" src={linkedinIcon} alt="Linked in Icon" />
                        <div className="text-content">
                            <h2>Linked in</h2>
                            <p>You can view my linked in profile <a className="link-in-text hover-underline-animation" href="https://www.linkedin.com/in/patrick-neil-5692a0133/">here</a>. Feel free to send me a message!</p>
                        </div>
                </article>
                <article className="single-contact-method">
                        <img className="contact-icon" src={githubIcon} alt="github icon" />
                        <div className="text-content">
                            <h2>Github</h2>
                            <p>My username is PLN-Projects click <a className="link-in-text hover-underline-animation" href="https://github.com/PLN-projects">here</a>  to view my repositories</p>
                        </div>
                </article>
                <article className="single-contact-method">
                        <img className="contact-icon" src={phoneIcon} alt="Phone Icon" />
                        <div className="text-content">
                            <h2>Phone</h2>
                            <p>I will send my phone number to those who request it via email.</p>
                        </div>
                </article>
                <article className="single-contact-method">
                        <img className="contact-icon" src={emailIcon} alt="Email Icon" />
                        <div className="text-content">
                            <h2>Email</h2>
                            <p>Click <a className="link-in-text hover-underline-animation" href="mailto:patrick_neil@protonmail.com">here</a> if you like to send me an email.</p>
                        </div>
                </article>
            </section>
        </section>
    )
}

export default Contact;
